import { ClothesEmploye } from "./clothesEmployeModel";
import { ClothesModel } from "./clothesModel";
import { EmployeModel } from "./employeModel";

export class ResponseInfoClothesEmployeModel {

    clothes: ClothesModel[];
    clothesEmployes: ClothesEmploye[];
    employee: EmployeModel;

    constructor() { }
}